module.exports = __webpack_public_path__ + "static/media/laptop.4acaec8f.svg";